import { Link, NavLink, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useAuthStore } from '@store'
import { ROUTES } from '@constants'
import { storageURL, mediaUrl } from '@config'
import { notificationService } from '@services/api/notifications'
import { conversationService } from '@services/api/messages'
import DownloadAppModal from '@components/common/DownloadAppModal'

const ICONS = {
  home: 'M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25',
  tag: 'M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z M6 6h.008v.008H6V6z',
  cart: 'M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z',
  phone: 'M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3',
  chat: 'M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z',
  bell: 'M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0',
  grid: 'M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z',
  user: 'M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z',
  logout: 'M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9',
  menu: 'M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5',
  login: 'M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75',
  userPlus: 'M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z',
  close: 'M6 18L18 6M6 6l12 12',
}

const Icon = ({ d, className = 'w-5 h-5', strokeWidth = 1.8 }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d={d} />
  </svg>
)

const NAV_LINKS = [
  { to: ROUTES.HOME, label: 'Accueil', icon: 'home', end: true },
  { to: ROUTES.PRICING, label: 'Tarification', icon: 'tag' },
  { to: ROUTES.LIGDI, label: 'KUDHI Market', icon: 'cart' },
]

const Badge = ({ count }) =>
  count > 0 ? (
    <span className="absolute -top-1 -right-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white">
      {count > 99 ? '99+' : count}
    </span>
  ) : null

function Header() {
  const { isAuthenticated, user, logout } = useAuthStore()
  const { pathname } = useLocation()
  const rawPhoto = user?.photo_profil || user?.photo || null
  const userPhoto = rawPhoto
    ? (rawPhoto.startsWith('http') ? rawPhoto
      : rawPhoto.startsWith('/storage/') ? `${storageURL.replace(/\/storage$/, '')}${rawPhoto}`
      : mediaUrl(rawPhoto))
    : null
  const initials = [
    (user?.nom || user?.name || '').charAt(0),
    (user?.prenom || '').charAt(0)
  ].filter(Boolean).join('').toUpperCase() || 'U'

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [downloadOpen, setDownloadOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [notifCount, setNotifCount] = useState(0)
  const [msgCount, setMsgCount] = useState(0)

  useEffect(() => {
    if (!isAuthenticated) return

    const fetchCounts = async () => {
      try {
        const [notifRes, convRes] = await Promise.allSettled([
          notificationService.getNotifications(),
          conversationService.getConversations(),
        ])
        if (notifRes.status === 'fulfilled' && notifRes.value?.success) {
          setNotifCount(notifRes.value.data.filter(n => !n.is_read).length)
        }
        if (convRes.status === 'fulfilled' && convRes.value?.success) {
          setMsgCount(convRes.value.data.reduce((s, c) => s + (c.unread_count || 0), 0))
        }
      } catch { /* compteurs non bloquants */ }
    }

    fetchCounts()
    const interval = setInterval(fetchCounts, 30000)
    return () => clearInterval(interval)
  }, [isAuthenticated])

  // Ombre une fois la page défilée (tailles inchangées)
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Ferme le menu mobile à chaque changement de page
  useEffect(() => { setMobileMenuOpen(false) }, [pathname])

  const handleLogout = () => {
    logout()
  }

  // Lien texte avec trait doré sous la page active
  // Les pages détail (article, vidéo, bannière) appartiennent au Market
  const isMarketDetail = /^\/(product|video|banner|staff-banner)\//.test(pathname)

  const navLinkClass = ({ isActive }) =>
    `relative inline-flex items-center gap-1.5 py-2 text-[15px] font-semibold transition-colors after:absolute after:left-0 after:-bottom-0.5 after:h-[3px] after:rounded-full after:bg-[#F5B700] after:transition-all after:duration-300 ${
      isActive ? 'text-[#002A4E] after:w-full' : 'text-slate-600 hover:text-[#002A4E] after:w-0 hover:after:w-full'
    }`

  const mobileLinkClass = ({ isActive }) =>
    `flex items-center gap-3 rounded-md px-4 py-3 text-base font-semibold transition-colors ${
      isActive ? 'bg-[#FFF8D6] text-[#002A4E]' : 'text-slate-700 hover:bg-slate-50'
    }`

  return (
    <header
      className={`home-font sticky top-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? 'border-amber-100/70 bg-[#FFFCF3]/90 shadow-[0_8px_30px_-12px_rgba(0,42,78,0.18)] backdrop-blur-md'
          : 'border-amber-100/70 bg-[#FFFCF3]'
      }`}
    >
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="flex h-20 items-center justify-between gap-6">
          {/* Logo */}
          <Link to={ROUTES.HOME} className="flex flex-shrink-0 items-center" aria-label="KUDHI, accueil">
            <img
              src="/Logo_LIGDI.png"
              alt="KUDHI"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Navigation desktop */}
          <nav className="hidden lg:flex flex-1 items-center justify-end gap-8">
            {NAV_LINKS.map(({ to, label, icon, end }) => (
              <NavLink key={to} to={to} end={end} className={({ isActive }) => navLinkClass({ isActive: isActive || (to === ROUTES.LIGDI && isMarketDetail) })}>
                {icon === 'cart' && <Icon d={ICONS.cart} className="w-[18px] h-[18px]" />}
                {label}
              </NavLink>
            ))}
            <button
              type="button"
              onClick={() => setDownloadOpen(true)}
              className={navLinkClass({ isActive: false })}
            >
              <Icon d={ICONS.phone} className="w-[18px] h-[18px]" />
              Télécharger l&apos;app
            </button>
          </nav>

          {/* Actions desktop */}
          <div className="hidden lg:flex items-center gap-2 border-l border-amber-200/70 pl-6">
            {isAuthenticated ? (
              <>
                <NavLink
                  to={ROUTES.DASHBOARD}
                  className="inline-flex items-center gap-2 rounded-md bg-[#FFD700] px-4 py-2.5 text-sm font-bold text-[#002A4E] shadow-sm shadow-amber-300/50 transition-all hover:-translate-y-0.5 hover:shadow-md"
                >
                  <Icon d={ICONS.grid} className="w-4 h-4" strokeWidth={2} />
                  Mon espace
                </NavLink>

                <Link to={ROUTES.MESSAGES} aria-label="Messages" className="relative flex h-10 w-10 items-center justify-center rounded-md text-[#002A4E] transition-colors hover:bg-white">
                  <Icon d={ICONS.chat} className="w-[22px] h-[22px]" />
                  <Badge count={msgCount} />
                </Link>

                <Link to={ROUTES.NOTIFICATIONS} aria-label="Notifications" className="relative flex h-10 w-10 items-center justify-center rounded-md text-[#002A4E] transition-colors hover:bg-white">
                  <Icon d={ICONS.bell} className="w-[22px] h-[22px]" />
                  <Badge count={notifCount} />
                </Link>

                <Link to={ROUTES.PROFILE} aria-label="Mon profil" className="ml-1">
                  {userPhoto ? (
                    <img
                      src={userPhoto}
                      alt=""
                      className="h-10 w-10 rounded-full object-cover ring-2 ring-[#FFD700] ring-offset-2 ring-offset-[#FFFCF3] transition-transform hover:scale-105"
                      onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex' }}
                    />
                  ) : null}
                  <div
                    className="h-10 w-10 items-center justify-center rounded-full bg-[#002A4E] text-sm font-bold text-[#FFD700] ring-2 ring-[#FFD700] ring-offset-2 ring-offset-[#FFFCF3] select-none"
                    style={{ display: userPhoto ? 'none' : 'flex' }}
                  >
                    {initials}
                  </div>
                </Link>

                <button
                  onClick={handleLogout}
                  aria-label="Déconnexion"
                  title="Déconnexion"
                  className="flex h-10 w-10 items-center justify-center rounded-md text-slate-500 transition-colors hover:bg-red-50 hover:text-red-600"
                >
                  <Icon d={ICONS.logout} className="w-[22px] h-[22px]" />
                </button>
              </>
            ) : (
              <>
                <Link
                  to={ROUTES.LOGIN}
                  className="inline-flex items-center gap-2 rounded-md border border-slate-200 bg-white px-4 py-2.5 text-[15px] font-semibold text-[#002A4E] transition-colors hover:border-slate-300 hover:bg-slate-50"
                >
                  <Icon d={ICONS.login} className="w-[18px] h-[18px]" />
                  Connexion
                </Link>
                <Link
                  to={ROUTES.REGISTER}
                  className="inline-flex items-center gap-2 rounded-md bg-[#FFD700] px-4 py-2.5 text-[15px] font-bold text-[#002A4E] shadow-sm shadow-amber-300/60 transition-all hover:-translate-y-0.5 hover:bg-[#F5C800]"
                >
                  <Icon d={ICONS.userPlus} className="w-[18px] h-[18px]" strokeWidth={2} />
                  S&apos;inscrire
                </Link>
              </>
            )}
          </div>

          {/* Burger menu mobile */}
          <button
            className="lg:hidden flex h-11 w-11 items-center justify-center rounded-md text-[#002A4E] transition-colors hover:bg-white/70"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={mobileMenuOpen}
          >
            <Icon d={mobileMenuOpen ? ICONS.close : ICONS.menu} className="w-6 h-6" strokeWidth={2} />
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      <div className={`lg:hidden grid transition-all duration-300 ${mobileMenuOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0 pointer-events-none'}`}>
        <div className="overflow-hidden">
          <div className="w-[90%] md:w-[80%] mx-auto pb-5">
            <nav className="rounded-md bg-white p-2 shadow-xl ring-1 ring-slate-100">
              {NAV_LINKS.map(({ to, label, icon, end }) => (
                <NavLink key={to} to={to} end={end} className={({ isActive }) => mobileLinkClass({ isActive: isActive || (to === ROUTES.LIGDI && isMarketDetail) })}>
                  <Icon d={ICONS[icon]} />
                  {label}
                </NavLink>
              ))}
              <button
                type="button"
                onClick={() => { setMobileMenuOpen(false); setDownloadOpen(true) }}
                className="flex w-full items-center gap-3 rounded-md px-4 py-3 text-left text-base font-semibold text-slate-700 transition-colors hover:bg-slate-50"
              >
                <Icon d={ICONS.phone} />
                Télécharger l&apos;app
              </button>

              <div className="my-2 h-px bg-slate-100" />

              {isAuthenticated ? (
                <>
                  <NavLink to={ROUTES.DASHBOARD} className={mobileLinkClass}>
                    <Icon d={ICONS.grid} />
                    Mon espace
                  </NavLink>
                  <NavLink to={ROUTES.MESSAGES} className={mobileLinkClass}>
                    <Icon d={ICONS.chat} />
                    Messages
                    {msgCount > 0 && <span className="ml-auto rounded-full bg-red-500 px-2 py-0.5 text-xs font-bold text-white">{msgCount > 99 ? '99+' : msgCount}</span>}
                  </NavLink>
                  <NavLink to={ROUTES.NOTIFICATIONS} className={mobileLinkClass}>
                    <Icon d={ICONS.bell} />
                    Notifications
                    {notifCount > 0 && <span className="ml-auto rounded-full bg-red-500 px-2 py-0.5 text-xs font-bold text-white">{notifCount > 99 ? '99+' : notifCount}</span>}
                  </NavLink>
                  <NavLink to={ROUTES.PROFILE} className={mobileLinkClass}>
                    <Icon d={ICONS.user} />
                    Profil
                  </NavLink>
                  <button
                    onClick={handleLogout}
                    className="flex w-full items-center gap-3 rounded-md px-4 py-3 text-left text-base font-semibold text-red-600 transition-colors hover:bg-red-50"
                  >
                    <Icon d={ICONS.logout} />
                    Déconnexion
                  </button>
                </>
              ) : (
                <div className="grid grid-cols-2 gap-2 p-2">
                  <Link to={ROUTES.LOGIN} className="inline-flex items-center justify-center gap-2 rounded-md border border-slate-200 py-3 font-semibold text-[#002A4E] transition-colors hover:bg-slate-50">
                    <Icon d={ICONS.login} className="w-[18px] h-[18px]" />
                    Connexion
                  </Link>
                  <Link to={ROUTES.REGISTER} className="inline-flex items-center justify-center gap-2 rounded-md bg-[#FFD700] py-3 font-bold text-[#002A4E] shadow-sm shadow-amber-300/50">
                    <Icon d={ICONS.userPlus} className="w-[18px] h-[18px]" strokeWidth={2} />
                    S&apos;inscrire
                  </Link>
                </div>
              )}
            </nav>
          </div>
        </div>
      </div>

      <DownloadAppModal open={downloadOpen} onClose={() => setDownloadOpen(false)} />
    </header>
  )
}

export default Header
